var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6F73FCD8-21C5-4E21-BC85-63706560E187@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AMP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMP_v1",
    transform: "translate(-863.000000, -3676.000000)",
    fill: "#6F7B91",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(863.000000, 3676.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.0070801 18.9975586 19.2116699 16 14.0070801 13.0024414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.16479494,0 0,7.16479494 0,16 C0,24.8352051 7.16479494,32 16,32 C24.8352051,32 32,24.8352051 32,16 C32,7.16479494 24.8352051,0 16,0 Z M25.9976446,16.0163574 C25.9976446,16.0163574 25.9976446,19.2612305 25.5859375,20.8259278 C25.3552246,21.6823731 24.6799316,22.357666 23.8234863,22.5881348 C22.2587891,23 16,23 16,23 C16,23 9.75756837,23 8.17651369,22.5717774 C7.32006837,22.3413086 6.64477538,21.6657715 6.4140625,20.8093262 C6.00219725,19.2612305 6.00219725,16 6.00219725,16 C6.00219725,16 6.00219725,12.7553711 6.4140625,11.1906738 C6.64453125,10.3342285 7.33642575,9.642334 8.17651369,9.41186525 C9.74121094,9 16,9 16,9 C16,9 22.2587891,9 23.8234863,9.42822263 C24.6799316,9.65869138 25.3552246,10.3342285 25.5859375,11.1906738 C26.0141601,12.7553711 25.9976446,16.0163574 25.9976446,16.0163574 L25.9976446,16.0163574 Z",
    id: "Shape"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGrey);
export default ForwardRef;